// Shared JSON-LD builders for SEO routes
const SITE = "https://www.aiforhrmastermind.com";

export const breadcrumb = (items: { name: string; path: string }[]) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: item.name,
    item: `${SITE}${item.path}`,
  })),
});

export const educationEvent = (event: {
  name: string;
  description: string;
  startDate: string;
  endDate: string;
  url: string;
  eventAttendanceMode?: string;
  eventStatus?: string;
}) => ({
  "@context": "https://schema.org",
  "@type": "EducationEvent",
  name: event.name,
  description: event.description,
  startDate: event.startDate,
  endDate: event.endDate,
  eventAttendanceMode:
    event.eventAttendanceMode ?? "https://schema.org/OnlineEventAttendanceMode",
  eventStatus: event.eventStatus ?? "https://schema.org/EventScheduled",
  location: {
    "@type": "VirtualLocation",
    url: event.url,
  },
  organizer: {
    "@type": "Organization",
    name: "AI for HR Mastermind",
    url: SITE,
  },
  offers: {
    "@type": "Offer",
    price: "0",
    priceCurrency: "USD",
    availability: "https://schema.org/InStock",
    url: event.url,
  },
});

export const courseWithNextCohort = (courseInstance: {
  name: string;
  startDate: string;
}) => ({
  "@context": "https://schema.org",
  "@type": "Course",
  name: "AI for HR Mastermind",
  description:
    "A 5-week cohort program where HR and People leaders work with an AI engineer and I/O Psychologist to build a working AI prototype for real HR workflows.",
  provider: {
    "@type": "Organization",
    name: "Workplace Labs",
    url: "https://www.workplacelabs.io",
  },
  offers: {
    "@type": "Offer",
    price: "1400",
    priceCurrency: "USD",
    availability: "https://schema.org/InStock",
    category: "Premium Membership — Lifetime Access",
  },
  hasCourseInstance: {
    "@type": "CourseInstance",
    ...courseInstance,
    courseMode: "Online",
    instructor: [
      { "@type": "Person", name: "Neil Morelli, PhD" },
      { "@type": "Person", name: "Jonathan Flower" },
    ],
  },
  numberOfCredits: 5,
  educationalLevel: "Professional",
  audience: {
    "@type": "Audience",
    audienceType:
      "HR Leaders, People Analytics, Talent Acquisition Professionals",
  },
});
